/**
 * Check if the path starts with "http://", "https://"
 * Should match the native url input type see: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/url
 */
export function getIsExternalLink(path: string): boolean {
  return /^https?:\/\//.test(path);
}
